export default __webpack_public_path__ + "static/media/logo.e58567b6.png";